
import GenreMaker from '../anychart/genreMaker'; 

var ColumnChart = class ColumnChart extends GenreMaker {

    createChart(){
        var chart = anychart.column();

        if(this.ifIncluded("3d")){
            chart = anychart.column3d();
          
        }

        return chart;
    }

    setData(state){ 
        super.setData(state);
        for (var series in this.data) {
            this.chart.column(this.data[series]);
        }
    }
}


    
GenreMaker.column = ColumnChart;

export var ColumnChart;



// WEBPACK FOOTER //
// ./src/anychart/columnChart.js